export type Clock = () => Date;

const ISO_UTC_PATTERN =
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,9})?Z$/;

export function toIsoUtc(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    throw new RangeError("Cannot format an invalid date.");
  }

  return date.toISOString();
}

export function nowIso(clock: Clock = () => new Date()): string {
  return toIsoUtc(clock());
}

export function isIsoUtc(value: string): boolean {
  const match = ISO_UTC_PATTERN.exec(value);
  if (!match) {
    return false;
  }

  const timestamp = Date.parse(value);
  if (!Number.isFinite(timestamp)) {
    return false;
  }

  const parsed = new Date(timestamp);
  const [, year, month, day, hour, minute, second] = match;
  return (
    parsed.getUTCFullYear() === Number(year) &&
    parsed.getUTCMonth() + 1 === Number(month) &&
    parsed.getUTCDate() === Number(day) &&
    parsed.getUTCHours() === Number(hour) &&
    parsed.getUTCMinutes() === Number(minute) &&
    parsed.getUTCSeconds() === Number(second)
  );
}
